import { ComponentBlock } from '@types';

import { types } from 'core/types';

import { component } from './component';
import { ProgressProps } from './index';

export const block: ComponentBlock<'progress', ProgressProps, unknown> = {
  id: 'progress',
  render: component,
  props: {
    value: {
      type: types.number,
    },
    list: {
      type: types.list,
    },
    property: {
      type: types.string,
    },
    size: {
      type: types.string,
    },
    colorScheme: {
      type: types.string,
    },
  },
};
